import type { MeResponse } from '@ucp/web/lib';

/**
 * The caller's distinct, sorted set of school-scoped assignments (platform-wide
 * `null` school ids excluded). Extracted from `SchoolSurfaces` into this
 * dependency-light module so the eagerly-loaded shell chrome (`RoutedAppShell`,
 * `AppHeader`) can use it WITHOUT importing `SchoolSurfaces` — which would drag the
 * (now lazy-loaded) `CrossSchoolOpsView` into the initial bundle. `SchoolSurfaces`
 * re-exports it for back-compat.
 */
export function assignedSchoolIds(user: Pick<MeResponse, 'roles'>): string[] {
  return [
    ...new Set(
      user.roles
        .map((role) => role.schoolId)
        .filter((schoolId): schoolId is string => schoolId !== null),
    ),
  ].sort();
}
